<template>
  <div class="flex-col">
    <div class="text-14-black33-b margin-top-16">{{ label }}</div>
    <div
      v-for="(child, count) in children"
      :key="count"
      :class="groupBoxStyle"
      class="flex-col margin-top-16"
    >
      <!--操作bar-->
      <div
        v-if="showGroupHandlerBar"
        class="flex-row-center-jx flex-between padding-h-16 height-32"
        :class="repeatable ? 'border-bottom-1' : 'border-eb-1'"
      >
        <div class="barTitle flex-row-center-jx">
          <span v-show="repeatable" class="text-14-black33"
            >{{ label }}{{ count + 1 }}</span
          >
        </div>
        <div class="flex">
          <span v-if="hintLabel" class="text-14-gray99">{{ hintLabel }}</span>
          <div
            v-if="ocrConfigs && ocrConfigs.length > 0"
            class="scanArea flex-row-center-jx"
          >
            <div
              v-for="(config, index) in ocrConfigs"
              :key="index"
              class="margin-left-16"
            >
              <div
                v-if="showScanBtn(config, child)"
                @click="doOcr(count, config, child)"
                class="flex-row-center-jx btn-hover"
              >
                <i class="el-icon-camera color-orangeFF" />
                <span class="text-14-orangeFF margin-left-4">{{
                  config.label
                }}</span>
              </div>
            </div>
          </div>
          <el-dropdown
            v-if="distinctions && distinctions.length > 0"
            @command="handleCommand($event, child)"
          >
            <span class="el-dropdown-link text-14-orangeFF margin-left-16">
              {{ child[0].dropdownName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="item"
                v-for="(item, index) in distinctions"
                :key="index"
              >
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!--child内容-->
      <div class="flex-row flex-between">
        <div class="flex-array-h margin-bottom-16 match-parent-w">
          <div
            v-for="(pro, index) in child"
            :key="index"
            :class="getItemWidth(pro)"
          >
            <div
              :out-data="pro"
              @onValueChange="onFormValueChange(pro, $event, child, count)"
              :is="groupEssential"
            ></div>
          </div>
        </div>
        <div
          v-if="couldEdit"
          class="deleteBtn flex-col-center btn-hover"
          @click="deleteCur(child, count)"
        >
          <span class="text-14-gray66">{{
            count === 0 ? "重置" : "删除"
          }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="couldEdit"
      class="addNewBox height-40 flex-row-center btn-hover"
      @click="addNewOne"
    >
      <i class="el-icon-plus color-orangeFF" />
      <span class="text-14-orangeFF margin-left-4">新增{{ label }}</span>
    </div>
  </div>
</template>

<script>
import FormGroupSecondView from "../../formGroupSecond";
import ConditionSelectView from "../../conditionSelectView";
import BaseFormView from "../../formView";

export default {
  name: "formSelectView",
  components: { BaseFormView, FormGroupSecondView, ConditionSelectView },
  data() {
    return {
      label: "",
      value: null,
      items: null,
      ocrConfigs: null,
      type: "group",
      repeatable: false,
      required: false,
      key: null,
      children: [],
      restaurants: [], //装入自动填充的数据里面
      dialogVisible: false,
      curOcrIndex: -1,
      conditionView: "",
      groupSecond: "",
      groupEssential: "",
      distinctions: null,
      new_dropdownName: null,
      fixedData: [],
      marriageData: [],
      newDefinition: [],
    };
  },
  props: {
    groupData: {
      type: Object,
      default() {
        return null;
      },
    },
    disable: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  watch: {
    groupData: {
      handler(newValue) {
        // 外部数据发生变化
        console.log("groupData-newValue=", newValue);
        this.analysisData(newValue);
      },
      immediate: true,
    },
  },
  computed: {
    groupBoxStyle() {
      let style = "";
      if (this.repeatable) {
        style += " border-eb-1";
      }
      return style;
    },
    showGroupHandlerBar() {
      return this.repeatable || !this.$verify.isEmptyArray(this.ocrConfigs);
    },
    couldEdit() {
      return this.repeatable && !this.disable;
    },
    hintLabel() {
      if (!this.$verify.isEmptyArray(this.ocrConfigs)) {
        let ocrLabel = "";
        for (let i = 0; i < this.ocrConfigs.length; i++) {
          if (i > 0) {
            ocrLabel += "/";
          }
          ocrLabel += this.ocrConfigs[i].label;
          if (i === this.ocrConfigs.length - 1) {
            ocrLabel += "等";
          }
        }
        return ``;
      }
      return "";
    },
  },
  mounted() {
    this.conditionView = (resolve) => {
      require([`../../conditionSelectView`], resolve);
    };
    this.groupSecond = (resolve) => {
      require([`../../formGroupSecond`], resolve);
    };
    this.groupEssential = (resolve) => {
      require([`../../formView`], resolve);
    };
    this.$nextTick(() => {
      this.$root.$on("goBack_Vue", this.getModification);
    });
  },
  destroyed() {
    this.$root.$off("goBack_Vue", this.getModification);
  },
  methods: {
    showScanBtn(config, child) {
      let { ocr } = config;
      if (ocr !== "IDCardRead") return true;
      if (child[0].type !== "condition-select") return true;
      return child[0].value === "idCard" || child[0].value === "personal";
    },
    analysisData(newData) {
      this.fixedData = [];
      this.marriageData = [];
      this.children = [];
      let {
        label,
        key,
        value,
        items,
        ocrConfigs,
        ocrSelect,
        type,
        repeatable,
        required,
        children,
      } = newData;
      this.label = label;
      this.value = value;
      this.items = items;
      this.ocrConfigs = ocrConfigs;
      this.distinctions = ocrSelect;
      this.type = type;
      this.repeatable = repeatable;
      this.required = required;
      this.key = key;
      this.newDefinition = JSON.parse(JSON.stringify(items));
      if (children.length != 0) {
        if (
          children[0][0].type !== "condition-select" &&
          !this.$verify.isEmptyArray(ocrSelect)
        ) {
          children[0][0].dropdownName = ocrSelect[0].label;
        }
      }

      if (newData.key === "litigants") {
        let processingData = children;
        processingData.forEach((value) => {
          let assembleData = []; //固定数据
          let cacheMarriageData = []; //固定婚姻数据
          value.forEach((resItem) => {
            if (!resItem.conditionValue) {
              assembleData.push(resItem);
            } else {
              cacheMarriageData.push(resItem);
            }
            if (resItem.label === "角色") {
              let newDist = [];
              resItem.opinions.forEach((newValue) => {
                newDist.push(newValue.value);
              });
              resItem.opinions.forEach((res) => {
                newDist.push(res.value);
                if (resItem.value) {
                  if (resItem.value.length === 0) {
                    res["disabled"] = false;
                  } else if (
                    resItem.value.indexOf("debit") !== -1 ||
                    resItem.value.indexOf("debit_spouse") !== -1
                  ) {
                    if (
                      res.value === "joint_liquidates" ||
                      res.value === "joint_liquidates_spouse"
                    ) {
                      res["disabled"] = true;
                    }
                  } else if (
                    resItem.value.indexOf("joint_liquidates") !== -1 ||
                    resItem.value.indexOf("joint_liquidates_spouse") !== -1
                  ) {
                    if (res.value === "debit" || res.value === "debit_spouse") {
                      res["disabled"] = true;
                    }
                  }
                  //后端会返回一些不是角色的值在value里面这个时候要单独剔除来
                  resItem.value.forEach((itemRef, index) => {
                    if (newDist.indexOf(itemRef) === -1) {
                      resItem.value.splice(index, 1);
                    }
                  });
                } else {
                  res["disabled"] = false;
                }
              });
            }
          });

          this.fixedData.push(JSON.parse(JSON.stringify(assembleData)));
          assembleData.forEach((refItem) => {
            if (refItem.label === "婚姻状况") {
              cacheMarriageData.forEach((new_value) => {
                if (new_value.conditionValue === refItem.value) {
                  assembleData.push(new_value);
                } else {
                  new_value.required = false;
                }
              });
            }
          });
          this.marriageData.push(JSON.parse(JSON.stringify(cacheMarriageData)));
          this.children.push(assembleData);
        });
      }
      localStorage.setItem("marriageData", JSON.stringify(this.marriageData));
    },
    onFormValueChange(item, newValue, currentChild, count) {
      let newCaching = JSON.parse(localStorage.getItem("restaurants"));
      
      this.fixedData[count].forEach((ref) => {
        if (ref.key === item.key) {
          ref.value = newValue;
        }
      });
        
      if (item.label === "婚姻状况") {
        let newFixedChange = [];
        newFixedChange = JSON.parse(JSON.stringify(this.fixedData));
        this.marriageData[count].forEach((resValue) => {
          if (resValue.conditionValue === newValue) {
            newFixedChange[count].push(resValue);
          } else {
            resValue.required = false;
          }
        });
        this.children[count] = newFixedChange[count];
        localStorage.setItem("marriageData", JSON.stringify(this.marriageData));
      }

      if (item.label === "角色") {
        this.children[count].forEach((value) => {
          if (value.label === "角色") {
            value.opinions.forEach((res) => {
              if (newValue.length === 0) {
                res["disabled"] = false;
              } else if (
                newValue.indexOf("debit") != -1 ||
                newValue.indexOf("debit_spouse") != -1
              ) {
                if (
                  res.value === "joint_liquidates" ||
                  res.value === "joint_liquidates_spouse"
                ) {
                  res["disabled"] = true;
                }
              } else if (
                newValue.indexOf("joint_liquidates") != -1 ||
                newValue.indexOf("joint_liquidates_spouse") != -1
              ) {
                if (res.value === "debit" || res.value === "debit_spouse") {
                  res["disabled"] = true;
                }
              }
            });
          }
        });
      }
      if (Object.prototype.toString.call(newValue) !== "[object Object]") {
        this.$set(item, "value", newValue);
        // this.$emit('groupChildrenChange', this.children);
        this.handleGroupDataChildren(this.children);
        let parameter = {};
        let newIndex;
        currentChild.forEach((res) => {
          parameter[res.key] = res.value;
        });
        if (parameter["name"] && item.label !== "收件人") {
          newIndex = newCaching.findIndex((item) => {
            return item.name == parameter["name"];
          });
        }

        if (newIndex != -1 && newIndex != undefined) {
          newCaching[newIndex] = parameter;
        } else if (newIndex === -1) {
          newCaching.push(parameter);
        }
        localStorage.setItem("restaurants", JSON.stringify(newCaching));
      } else {
        for (let key in newValue) {
          currentChild.forEach((item) => {
            if (key === item.key) {
              item.value = newValue[key];
              this.$set(item, "value", newValue[key]);
            } else {
              if (item.key === "telePhone" && key == "telphone") {
                item.value = newValue[key];
                this.$set(item, "value", newValue[key]);
              }
            }
          });
        }
        this.groupEssential = "";
        this.groupEssential = (resolve) => {
          require([`../../formView`], resolve);
        };

        this.handleGroupDataChildren(this.children);
      }
    },
    handleGroupDataChildren(children) {
      let changeChildren = [],
        handleChildren = {};
      for (const child of children) {
        handleChildren =
          this.$dynamicTool.transaction.handleDynamicChildren(child);
        changeChildren.push(handleChildren || child);
      }

      if (this.$verify.isEmptyArray(changeChildren)) {
        this.$emit("groupChildrenChange", children);
        return;
      }
      this.children = [];
      this.$forceUpdate();
      this.$nextTick(() => {
        this.$set(this, "children", changeChildren);
      });

      this.$emit("groupChildrenChange", changeChildren);
    },
    groupDataChange(groupData, children) {
      this.$set(groupData, "children", children);
      this.$emit("groupChildrenChange", this.children);
    },
    onConditionChange(item, newItem) {
      // 将newItem中改变的值赋值给item
      for (const newItemKey in newItem) {
        if (newItem.hasOwnProperty(newItemKey)) {
          let value = newItem[newItemKey];
          if (item.hasOwnProperty(newItemKey) && item[newItemKey] === value) {
            continue;
          }
          if (
            newItemKey === "value" &&
            !this.$verify.isEmptyArray(this.distinctions)
          ) {
            // 如果条件发生变化了-修改其dropdownName值
            let findOne = this.distinctions.find(
              (config) => config.condition === newItem.value
            );
            if (this.$verify.isEmpty(findOne)) {
              if (
                this.$const.ocrMapRe &&
                this.$const.ocrMapRe.hasOwnProperty(newItem.value)
              ) {
                let reKey = this.$const.ocrMapRe[newItem.value]; // 取得特殊映射
                findOne = this.distinctions.find(
                  (config) => config.condition === reKey
                );
              } else {
                // 没得映射
                findOne = { label: "请选择" };
              }
            }
            item.dropdownName = findOne.label;
          }
          this.$set(item, newItemKey, value);
        }
      }
      this.$emit("groupChildrenChange", this.children);
    },
    async addNewOne() {
      try {
        
        await this.$dynamicTool.fun.forbidDoubleClick("addNewOne");
        let items = this.items;
        let newOne = JSON.parse(JSON.stringify(items));
        let assembleData = [];
        let cacheMarriageData = [];
        
        if (!this.$verify.isEmptyArray(this.distinctions)) {
          newOne[0].dropdownName = this.distinctions[0].label;
        }
        
        if (this.key === "litigants" ) {
          newOne.forEach((value) => {
            if (!value.conditionValue) {
              assembleData.push(value);
            } else {
              cacheMarriageData.push(value);
            }
          });
        
          this.children.push(assembleData);
          this.fixedData.push(JSON.parse(JSON.stringify(assembleData)));
          this.marriageData.push(JSON.parse(JSON.stringify(cacheMarriageData)));
          localStorage.setItem(
            "marriageData",
            JSON.stringify(this.marriageData)
          );
        }
        if(this.key === "counterGuarantor"){
            this.children.push(newOne);
          }
        this.$emit("groupChildrenChange", this.children);
      } catch (e) {
        this.$dynamicTool.ui.errorToast(e);
      }
    },
    async deleteCur(children, position) {
      try {
        await this.$dynamicTool.fun.forbidDoubleClick("deleteCur");
        if (position === 0) {
          // 清除当前数据
          let child0 = this.children[0];
          let copy = JSON.parse(JSON.stringify(child0));
          for (const childPro of copy) {
            childPro.value = undefined;
            if (childPro.key === "roles" && childPro.label === "角色") {
              childPro.value = [];
            }
            childPro.children = [];
          }
          let newRedefinition = this.fixedData[0];
          for (const items of newRedefinition) {
            items.value = undefined;
            if (items.key === "roles" && items.label === "角色") {
              items.value = [];
            }
            items.children = [];
          }
          this.$set(this.children, 0, copy);
        } else {
          this.children.splice(position, 1);
        }
        this.$emit("groupChildrenChange", this.children);
      } catch (e) {
        this.$dynamicTool.ui.errorToast(e);
      }
    },
    //点击下拉
    handleCommand(command, child) {
      console.log("下拉菜单value选择-command=", command, "\nchild=", child);
      if (
        this.$verify.isEmpty(command) ||
        this.$verify.isEmpty(command.condition)
      )
        return;
      let { label, condition } = command,
        finalValue = condition;
      if (child[0].type !== "condition-select") {
        child[0].dropdownName = label;
        return;
      }
      if (!this.$verify.isEmptyArray(child[0].opinions)) {
        let exist = child[0].opinions.some(
          (option) => option.value === condition
        );
        if (!exist) {
          // 不存在-就去全局map中找ocr映射
          if (
            this.$const.ocrMap &&
            this.$const.ocrMap.hasOwnProperty(condition)
          ) {
            finalValue = this.$const.ocrMap[condition];
          } else {
            // 找不到就不进行赋值
            this.$root.$emit("jqBridge", {
              event: "toast",
              data: { msg: "对应参数有误，请联系相关人员", flag: false },
            });
            return;
          }
        }
        // 直接赋值进行后续
        child[0].value = finalValue;
        child[0].dropdownName = label;
        child[0].children = [];
        return;
      }
      this.$root.$emit("jqBridge", {
        event: "toast",
        data: { msg: "对应参数有误，请联系相关人员", flag: false },
      });
    },
    doOcr(index, ocrInfo, child) {
      if (child[0].type === "condition-select")
        ocrInfo.condition = child[0].value;
      // 参数index和key都是后端需要的参数
      let ocrParam = {
        index,
        ocrInfo,
        key: this.key,
      };

      this.$root.$emit("jqBridge", { event: "doOcrNow", data: ocrParam });
    },
    getItemWidth(formItem) {
      let style = "";
      switch (formItem.type) {
        case "condition-picker":
        case "condition-select":
        case "group":
          style += " match-parent-w";
          break;
        case "hidden":
          style += " clearStyle";
          break;
        default:
          style += " margin-top-8 width-parent-48";
          break;
      }
      return style;
    },
    getModification($event) {
      console.log(this.ocrConfigs, "这个里面有好多的数据呢");
    },
    getReassemble() {},
  },
};
</script>

<style scoped lang="scss">
@import "src/css/form-style";
.border-bottom-1 {
  border-bottom: 1px solid #ebebeb;
}

.barTitle {
  min-width: 70px;
  height: 100%;
}

.ocrHint {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 40%;

  &:hover {
    text-overflow: inherit;
    overflow-x: scroll;
    white-space: nowrap;
  }
}

::v-deep .el-dropdown-link {
  cursor: pointer;
}
</style>
